import { get_user, ativar_desativar } from '../../../Services/user'

//Função que traz os dados do banco de dados
export const get = (page) =>{
    return[(dispatch,getState)=>{
        
        const order = getState().user.order
        const th = getState().user.th
        const qtd_per_page = getState().user.qtd_per_page
        const pesquisa = getState().user.pesquisa || ''
        const empresa_id = getState().auth.user.empresa_id
        
       
      
        get_user(page,qtd_per_page,order,th,pesquisa,empresa_id)
        .then(resp=>dispatch({type:'get_User', payload:resp.data}))

    }]
}

export const change_qtd_per_page = event => {
    return[{
        type:'qtd_per_pageUser',
        payload:event.target.value
    },get(1)]
}

export const changePesquisa = event => {
    return[{
        type:'pesquisaUser',
        payload:event.target.value
    }]
}

export const clearPesquisa = event => {
    return[{
        type:'clearPesquisaUser',
        payload:''
    },get(1)]
}

//Função que ordena as colunas
export const order = (coluna) => {
    return [(dispatch,getState)=>{
        const asc = getState().user.asc
      
        if(asc === true){
            dispatch({type:'GetUser_Desc', desc:true, asc:false,order:'desc',th:coluna})
            
        }if(asc === false){
            dispatch({type:'GetUser_Asc', asc:true, desc:false,order:'asc',th:coluna})
            
        }
     
    },get(1)]
    
    
}

export const handleCheeseChange = (event) =>{
    return[{
        type:'changeActiveUser',
        payload:event.target.checked === true ? (1):(0),
        id_check:event.target.id
        
    },changeStateActive()]
    
}

export const changeStateActive = () =>{
    return (dispatch,getState) => {
        const id = getState().user.id_check
        const check =parseInt(getState().user.check)
        const data = {
            ativo:check,
            
        }
        ativar_desativar(id, data)
        // axios.put(`${URLPOSTTECNICO}/${id}`,{check:parseInt(check)})
        .then(resp => dispatch(get(getState().user.users.current_page)))
        .catch(resp => dispatch(get(getState().user.users.current_page)))
    }
}
    